/*
 QR Code Mixins
 -------------------------------------------------
*/

import kjua from 'kjua'
import JSZip from 'jszip'

const DEFAULT_ICON = 'fa fa-qrcode'
const DEFAULT_MSG = 'Download QR Codes for Site Equipment'


export default {

  computed: {


    fileName: function () {
      return this.equip ? `${this.equip.id}|${this.equip.site.siteId}|${this.equip.organisation.shortName}-${this.equip.category}-${this.equip.type}` +
        (this.equip.subType ? `-${this.equip.subType}` : '') +
        (this.equip.variant ? `-${this.equip.variant}` : '') +
        (this.equip.installedOn ? `-${this.equip.installedOn}` : '') +
        (this.equip.qty ? `-QTY-${this.equip.qty}` : '') : null
    },


  },

  methods: {

    qrCodeInit(site = null, equip = null, ownerId = null) {
      this.site = site

      this.ownId = ownerId
      this.equip = equip

      this.zipFileName = this.site.siteId + '-' + this.site.latitude + '-' + this.site.longitude + '.zip'

    },



    qrTextItem (item) {
      return this.strIf(this.site.siteId, null, '|') +
        this.strIf(this.site.latitude, null, '|') +
        this.strIf(this.site.longitude, null, '|') +
        this.strIf(item.organisation.shortName, null, '|') +
        this.strIf(item.category, null, '|') +
        this.strIf(item.type, null, '|') +
        this.strIf(item.subType, null, '|') +
        this.strIf(item.variant, null, '|') +
        this.strIf(item.sector, null, '|') +
        this.strIf(item.level, null, '|') +
        this.strIf(item.diameter, null, '|') +
        this.strIf(item.heightOnTower, null, '|') +
        this.strIf(item.agl, null, 'm|') +
        this.strIf(item.serialNo, null, '|') +
        this.strIf(item.qty, null, '|') +
        this.strIf(this.formatDate(item.installedOn))
    },



    qrCodeSuccess (data) {
      this.equipList = data
      this.icon = 'fa fa-spinner fa-spin'
      this.qrCodeBtn = 'Processing Zip file...'
      this.enabled = false

      this.createZipFile()
    },


    qrCodeActions () {

      if (this.equipList.length === 0 && !this.zipFile) {

        this.fetchData('/assets/site/' + this.site.id + (this.ownId ? '/' + this.ownId : '') + '/qrcode', this.qrCodeSuccess)

      } else {

        if (this.zipFile) {
          this.enabled = true
          this.icon = 'fa fa-download'
          this.qrCodeBtn = 'Download QR Code Zip File...'

          var self = this

          this.zipFile.generateAsync({type: 'blob'}).then(function (blob) {
//            console.log('blob', blob)
            self.download(blob, self.zipFileName)
          }, function (err) {
            console.error(err)
            self.$notify({type: 'error', title: 'Error generating the zip file', message: err})
            self.icon = DEFAULT_ICON
            self.qrCodeBtn = DEFAULT_MSG

          })
        } else {
          this.$message({message: 'Something went wrong with downloading your zip file.', type: 'warning'})
        }

      }
    },



    qrCodeGenerate (item, text, textSize = 11) {

      let qr = {
        mode: 'label',
        text: item,
        eclevel: 'H',
        minVersion: 10,
        quiet: 1,
        size: 528,
        back: '#fff',
        label: this.strIf(text, null),
        fontname: 'sans',
        fontcolor: '#111',
        mSize: textSize
      }

      return kjua(qr)
    },


    qrCodeSite (item, equipList = null) {
      return this.qrCodeGenerate(this.qrTextSite(item, equipList), item.siteId, 6)
    },



    qrTextSite (item, equipList = null) {
      let qr = this.strIf(item.siteId, null, '\n') +
      this.strIf('lat:' + item.latitude, null, '|') +
      this.strIf('lng:' + item.longitude, null, '|') + '\n\n'

      let sm = null

      for (const i of equipList) {

        if (i.shortName !== sm) {
          qr = qr + '**' + i.shortName + '**\n'
          sm = i.shortName
        }

        qr = qr + this.strIf(i.qty, null, ' x ') +
          this.strIf(i.category, null, '/') +
          this.strIf(i.type, null, '/') +
          this.strIf(i.subType, null, '') +
          this.strIf(i.variant, null, '') +
          (i.diameter ? '| dia:' + this.strIf(i.diameter, null, '|') : '') +
          (i.serialNo ? '#' + this.strIf(i.serialNo, null, '|') : '') +
          this.strIf(this.formatDate(i.installedOn)) + '\n'

      }

      return qr
    },



    qrCodeText (item, keepSiteInfo = true) {
      let qr = ''

      if (keepSiteInfo) {
        qr = this.strIf(item.siteId, null, '|') +
          this.strIf('lat:' + item.latitude, null, '|') +
          this.strIf('lng:' + item.longitude, null, '|') +
          this.strIf(item.shortName, null, '|')
      }

      qr = qr + this.strIf(item.qty, null, ' x ') +
        this.strIf(item.category, null, '/') +
        this.strIf(item.type, null, '/') +
        this.strIf(item.subType, null, '/') +
        this.strIf(item.variant, null, '/') +
        this.strIf(item.sector, null, '|') +
        this.strIf(item.level, null, '|') +
        this.strIf(item.diameter, null, '|') +
        this.strIf(item.heightOnTower, null, '|') +
        this.strIf(item.agl, null, 'm|') +
        this.strIf(item.serialNo, null, '|') +
        this.strIf(this.formatDate(item.installedOn))

      return qr + '\n'
    },



    qrCodeAudit (item) {
      return this.strIf(item.siteId, null, '|') +
        this.strIf('lat:' + item.latitude, null, '|') +
        this.strIf('lng:' + item.longitude, null, '|') +
        this.strIf(item.shortName, null, '|') +
        this.strIf(item.category, null, '|') +
        this.strIf(item.type, null, '|') +
        this.strIf(item.subType, null, '|') +
        this.strIf(item.variant, null, '|') +
        this.strIf(item.diameter, null, '|')
    },


    extractImage (image) {
      if (image) {
        return image.src.substr(image.src.indexOf(',') + 1, image.src.length)
      }

      return null
    },



    extractImageType (image) {
      if (image) {
        return image.src.substr(image.src.indexOf('/') + 1, image.src.indexOf(':') - 1)
      }

      return null
    },



    createZipFile () {
      this.zipFile = new JSZip()
      let siteDone = false

      for (const item of this.equipList) {

        if (!siteDone) {
          let qrSite = this.qrCodeGenerate(this.qrTextSite(item, this.equipList), item.siteId, 6)
          this.zipFile.file(`${item.siteId}/site-qr-code.${this.extractImageType(qrSite)}`, this.extractImage(qrSite), {base64: true})
          siteDone = true
        }

        let qrc = this.qrCodeGenerate(this.qrCodeText(item), item.shortName)

        let image = this.extractImage(qrc)
        let imageType = this.extractImageType(qrc)

        this.zipFile.file(`${item.siteId}/${item.shortName}/${item.shortName}-${item.category}-${item.type}` + (item.subType ? `-${item.subType}` : '') + (item.variant ? `-${item.variant}` : '') + `-${item.id}.${imageType}`, image, {base64: true})

        let auditQr = this.qrCodeGenerate(this.qrCodeAudit(item), item.shortName)
        let auditImage = this.extractImage(auditQr)
        let auditImageType = this.extractImageType(auditQr)

        this.zipFile.file(`${item.siteId}/${item.shortName}/audit/${item.shortName}-${item.category}-${item.type}` + (item.subType ? `-${item.subType}` : '') + (item.variant ? `-${item.variant}` : '') + (item.diameter ? `-${item.diameter}` : '') + `.${auditImageType}`, auditImage, {base64: true})

      }

      this.qrCodeActions()
    }

  },

  data () {
    return {
      enabled: true,
      ownId: null,
      zipFile: null,
      zipFileName: null,
      equipList: [],
    }
  }  // data




}



// WEBPACK FOOTER //
// ./src/mixins/QrCodeMixins.js